"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/ispAmountInput/index.vue"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _utils = require("@/utils");
var _userGuideApi = require("@/api/basicInfo/userGuideApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default,
    amountInput: _index.default
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      statusList: [],
      classList: [],
      vesselTypeList: [],
      poolTypeList: [],
      form: {
        model: '',
        item: '',
        sequence: '',
        description: '',
        remark: '',
        status: '1'
      },
      yesNoList: [],
      rules: {
        model: [{
          required: true,
          message: this.$t('pool.pleaseEnter'),
          trigger: 'blur'
        }],
        item: [{
          required: true,
          message: this.$t('pool.pleaseEnter'),
          trigger: 'blur'
        }]
      },
      loading: null
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['YES_NO', 'POOL_STATUS'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.yesNoList = res.YES_NO;
      _this.statusList = res.POOL_STATUS;
    });
  },
  mounted: function mounted() {},
  methods: {
    handleCancel: function handleCancel() {
      var _this2 = this;
      this.$confirm(this.$t("pool.cancelTitle"), this.$t("common.message.hint"), {
        confirmButtonText: this.$t("common.btn.confirm"),
        cancelButtonText: this.$t("common.btn.cancel"),
        type: "warning"
      }).then(function () {
        _this2.$parent.setInitDialogVisible(false);
      });
    },
    opened: function opened() {
      var _this3 = this;
      this.$nextTick(function () {
        if (_this3.id) {
          //编辑
          _this3.handleInitEdit();
        } else {
          _this3.handleClear();
        }
      });
    },
    handleClear: function handleClear() {
      this.form = {
        model: '',
        item: '',
        sequence: '',
        description: '',
        remark: '',
        status: '1'
      };
    },
    closed: function closed() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs['form'].clearValidate();
        _this4.$parent.handleSearch();
      });
    },
    handleSave: function handleSave() {
      var _this5 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this5.loading = (0, _utils.load)();
          var saveForm = _this5.form;
          (0, _userGuideApi.save)(saveForm).then(function (res) {
            if (res.success) {
              _this5.$message({
                message: _this5.$t('common.message.saveSuccessfully'),
                type: 'success'
              });
              // this.id = res.data.id
              // this.handleInitEdit();
              _this5.$parent.setInitDialogVisible(false);
            } else {
              var errorMessages = res.errorMessages && res.errorMessages[0];
              if (!errorMessages) {
                errorMessages = _this5.$t('contract.failMessage');
              }
              _this5.$message({
                message: errorMessages,
                type: 'warning'
              });
            }
          }).catch(function () {}).finally(function () {
            _this5.loading.close();
          });
        }
      });
    },
    //编辑初始化
    handleInitEdit: function () {
      var _handleInitEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this6 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = (0, _utils.load)();
              _context.next = 3;
              return (0, _userGuideApi.getById)({
                id: this.id
              }).then(function (res) {
                if (res.data) {
                  _this6.form = res.data;
                  //计算vesselAge
                  _this6.builderDateChange(_this6.form.builderDate);
                }
                _this6.loading.close();
              }).catch(function () {
                _this6.loading.close();
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleInitEdit() {
        return _handleInitEdit.apply(this, arguments);
      }
      return handleInitEdit;
    }(),
    getLocalTime: function getLocalTime(i, d) {
      //参数i为时区值数字，比如北京为东八区则输入+8,西5输入-5
      //参数d为要转换的时间(Date类型)
      if (typeof i !== 'number') return;
      var len = new Date(d).getTime();
      //本地时间与GMT时间的时间偏移差
      return (0, _utils.parseTime)(new Date(len - 3600000 * i), '{y}-{m}-{d} {h}:{m}:{s}');
    }
  }
};